import ChildrenCategoriesTypeEnum from 'Rentlio/utils/childrenCategoriesEnum'

// all adults and children treatedd as adults go here
export function getTotalAdultsPrice(
  basePrice,
  { adults, children },
  { childrenDifferentThanAdults, childrenCategories }
) {
  if (childrenDifferentThanAdults) {
    let totalAdults = adults

    children.map(age =>
      childrenCategories.map(category => {
        if (age >= category.ageFrom && age < category.ageTo) {
          if (category.type === ChildrenCategoriesTypeEnum.AS_ADULT) {
            totalAdults++
          }
        }
      })
    )
    return basePrice * totalAdults
  }

  return basePrice * (adults + children.length)
}
